var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 14H8C7.46957 14 6.96086 13.7893 6.58579 13.4142C6.21071 13.0391 6 12.5304 6 12V8C6 7.46957 6.21071 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8 6H12C12.5304 6 13.0391 6.21071 13.4142 6.58579C13.7893 6.96086 14 7.46957 14 8V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM8 7.33333C7.82319 7.33333 7.65362 7.40357 7.5286 7.5286C7.40357 7.65362 7.33333 7.82319 7.33333 8V12C7.33333 12.1768 7.40357 12.3464 7.5286 12.4714C7.65362 12.5964 7.82319 12.6667 8 12.6667H12C12.1768 12.6667 12.3464 12.5964 12.4714 12.4714C12.5964 12.3464 12.6667 12.1768 12.6667 12V8C12.6667 7.82319 12.5964 7.65362 12.4714 7.5286C12.3464 7.40357 12.1768 7.33333 12 7.33333H8Z",
    fill: "#989BA2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.48667 10H3.78C3.30846 9.99824 2.85672 9.81014 2.52329 9.47671C2.18986 9.14328 2.00176 8.69155 2 8.22V3.78C2.00176 3.30846 2.18986 2.85672 2.52329 2.52329C2.85672 2.18986 3.30846 2.00176 3.78 2H8.22C8.69155 2.00176 9.14328 2.18986 9.47671 2.52329C9.81014 2.85672 9.99824 3.30846 10 3.78V6.26667H8.66667V3.78C8.66667 3.66154 8.61961 3.54793 8.53584 3.46416C8.45208 3.38039 8.33846 3.33333 8.22 3.33333H3.78C3.66154 3.33333 3.54793 3.38039 3.46416 3.46416C3.38039 3.54793 3.33333 3.66154 3.33333 3.78V8.22C3.33333 8.33846 3.38039 8.45208 3.46416 8.53584C3.54793 8.61961 3.66154 8.66667 3.78 8.66667H6.48667V10Z",
    fill: "#989BA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyGray);
export default __webpack_public_path__ + "static/media/icon_copy_gray.a2632ea58ef5bd649b86d5a0fa69834c.svg";
export { ForwardRef as ReactComponent };